import PosthogService from '~/services/posthog/PosthogService';

/**
 * Fires when an office clicks the "Review Shifts" button on the
 * "Add Invites" step of the NEW Shift Request flow (202603 design)
 * Event: dental_portal:shift_request:fill_preferences_submitted
 */
export function fireShiftRequestFillPreferencesSubmitted(): void {
  PosthogService.getInstance().track('dental_portal:shift_request:fill_preferences_submitted', {
    'Design Date': 202603,
  });
}
